var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7323 18.0022L13.7386 4.01311C13.5643 3.70555 13.3116 3.44974 13.0061 3.27175C12.7007 3.09377 12.3535 3 12 3C11.6465 3 11.2993 3.09377 10.9939 3.27175C10.6885 3.44974 10.4357 3.70555 10.2614 4.01311L2.26778 18.0022C2.09161 18.3074 1.99922 18.6536 2 19.006C2.00079 19.3583 2.0947 19.7042 2.27223 20.0085C2.44975 20.3129 2.70458 20.5648 3.01089 20.739C3.31719 20.9131 3.66408 21.0031 4.01639 20.9999H20.0036C20.3543 20.9996 20.6986 20.907 21.0021 20.7314C21.3056 20.5559 21.5576 20.3036 21.7328 19.9998C21.9079 19.6961 22.0001 19.3516 22 19.001C21.9999 18.6503 21.9076 18.3059 21.7323 18.0022Z",
    stroke: "#E7000B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V13",
    stroke: "#E7000B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H12.01",
    stroke: "#E7000B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.74a6f55c86176bed05c0f6a80ca40b4c.svg";
export { ForwardRef as ReactComponent };